import { render, staticRenderFns } from "./visi.vue?vue&type=template&id=2cb129ae&"
import script from "./visi.vue?vue&type=script&lang=js&"
export * from "./visi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInput,QBtn,QList,QExpansionItem,QItemSection,QAvatar,QCard,QCardSection,QSeparator,QPagination} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QInput,QBtn,QList,QExpansionItem,QItemSection,QAvatar,QCard,QCardSection,QSeparator,QPagination})
